<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
import GridView from "../../../components/common/GridView";
import moment from "moment";
export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('clockdata.clockdata'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('columns.staffno'), value: "staffcode", width: "200px" },
        { text: this.$t('columns.name'), value: "psnname", width: "200px" },
        { text: this.$t('columns.date'), value: "clockdate", width: "100px" },
        { text: this.$t('payrollsummarylistingreport.time'), value: "clocktime", width: "100px" },
        { text: this.$t('clockdata.inout'), value: "indicator", width: "50px" },
        { text: this.$t('clockdata.deviceid'), value: "devicedesc", width: "100px" },
        { text: this.$t('columns.reason'), value: "reasondesc", width: "100px" },
        { text: this.$t('clockdata.uploadtime'), value: "uploadedtime", width: "100px" },
        { text: this.$t('clockdata.source'), value: "datesource", width: "100px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getClockDataHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/clockdata/all"})
        .then(function (res) {
          // vm.dataItems = res.data.rec;
          for (var i = 0; i < res.data.rec.length; i++) {
            vm.dataItems.push({
              action: 1,
              id: res.data.rec[i].id,
              staffid: res.data.rec[i].staffid,
              staffcode: res.data.rec[i].staffcode,
              psnname: res.data.rec[i].psnname,
              clockdate: moment(res.data.rec[i].clockdate).format("YYYY-MM-DD"),
              clocktime: res.data.rec[i].clocktime,
              indicator: res.data.rec[i].indicator,
              device: res.data.rec[i].device,
              devicecode: res.data.rec[i].devicecode,
              devicedesc: res.data.rec[i].devicedesc,
              reason: res.data.rec[i].reason,
              reasoncode: res.data.rec[i].reasoncode,
              reasondesc: res.data.rec[i].reasondesc,
              datesource: res.data.rec[i].datesource,
              uploadedtime: res.data.rec[i].uploadedtime ? moment(res.data.rec[i].uploadedtime).format("YYYY-MM-DD HH:mm:ss") : null,
            });
          }

          console.log(vm.dataItems);

          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({
        name: "clockdataedit",
        params: { id: item.id, search: item.search },
      });
    },

    newRecordHandler() {
      this.$router.push({ name: "clockdatanew" });
    },
  },

  mounted() {
    this.getClockDataHandler();
  },
};
</script>